import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Paper from '@material-ui/core/Paper';

import CaseList from './components/CaseList/CaseList';
import Filter from '@components/Filter/Filter';
import FlexContainer from '@components/FlexContainer/FlexContainer';
import Search from '@components/Search/Search';

import {
  getCases,
  setSortBy,
  setSearchQuery,
} from '@actions/cases';

import {
  caseData,
  sortBy,
  sortByOptions,
  searchQuery,
} from '@selectors/cases';

import './Cases.scss';

class Cases extends React.Component {
  componentDidMount() {
    this.props.fetchCases();
  }

  render() {
    const {
      data,
      searchQuery,
      setSearchQuery,
      setSortBy,
      sortBy,
      sortByOptions,
    } = this.props;

    return (
      <FlexContainer>
        <div className="cases__filters">
          <Paper className="cases__search">
            <Search
              placeholder="Search a case..."
              searchQuery={searchQuery}
              setSearchQuery={event => setSearchQuery(event, sortBy)}
            />
          </Paper>
          <Paper className="cases__sorter">
            <Filter
              sortBy={sortBy}
              sortByOptions={sortByOptions}
              setSortBy={event => setSortBy(event, searchQuery)}
            />
          </Paper>
        </div>
        <Paper className="cases__list">
          <CaseList data={data} />
        </Paper>
      </FlexContainer>
    );
  }
}

Cases.propTypes = {
  sortBy: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
  sortByOptions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    caseNumber: PropTypes.string,
    court: PropTypes.string,
    filingDate: PropTypes.string,
  })),
  setSortBy: PropTypes.func.isRequired,
  fetchCases: PropTypes.func.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
};

Cases.defaultProps = {
  data: [],
};

const mapStateToProps = state => ({
  data: caseData(state),
  sortBy: sortBy(state),
  sortByOptions: sortByOptions(state),
  searchQuery: searchQuery(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCases: getCases,
  setSortBy: (event, searchQuery) => setSortBy(event, searchQuery),
  setSearchQuery: (event, sortBy) => setSearchQuery(event, sortBy),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Cases);



// WEBPACK FOOTER //
// ./src/routes/Cases/Cases.js